import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiUrl } from '../utils/api';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(apiUrl('/api/blog'));
        if (!res.ok) throw new Error('Failed to fetch blogs');
        const data = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error('Failed to fetch blogs:', err);

        // Fallback to static blogs
        setBlogs([
          {
            id: 1,
            title: 'Understanding Mental Health',
            createdAt: '2023-01-15',
            summary: 'Learn about the importance of mental health and how to take care of it.',
            imageUrl: '', // fallback image if needed
          },
          {
            id: 2,
            title: 'Tips for Managing Anxiety',
            createdAt: '2023-02-10',
            summary: 'Discover practical tips to manage anxiety in your daily life.',
          },
          {
            id: 3,
            title: 'The Role of Therapy in Mental Wellness',
            createdAt: '2023-03-05',
            summary: 'Explore how therapy can help improve your mental well-being.',
          },
          {
            id: 4,
            title: 'Overcoming Stress at Work',
            createdAt: '2023-04-20',
            summary: 'Strategies to reduce stress and maintain a healthy work-life balance.',
          },
          {
            id: 5,
            title: 'Building Resilience',
            createdAt: '2023-05-15',
            summary: 'Learn how to build resilience and cope with life’s challenges.',
          },
        ]);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="font-sans max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8 text-center">Blog</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {blogs.map((blog) => (
          <div key={blog.id} className="bg-white rounded-lg shadow-md overflow-hidden transition hover:shadow-lg">
            <img
              src={blog.imageUrl || `https://picsum.photos/seed/${blog.id}/800/400`}
              alt="Blog"
              className="w-full h-48 object-cover"
            />

            <div className="p-6">
              <h2 className="text-xl font-semibold text-blue-800 mb-2">{blog.title}</h2>
              <p className="text-sm text-gray-500 mb-2">
                {new Date(blog.createdAt).toDateString()}
              </p>
              <p className="text-gray-700 mb-4">{blog.summary}</p>
              <Link
                to={`/blog/${blog.id}`}
                className="text-blue-600 hover:underline text-sm"
              >
                Read more →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
